// Catalog ("store") grouping metadata for the full service directory.
// Labels only — no pricing. Quotes are given by staff via phone / LINE / email.

export type CatalogCategory =
  | "notary"
  | "translation"
  | "legalization"
  | "background"
  | "visa-marriage";

export interface CatalogGroup {
  id: CatalogCategory;
  labelTh: string;
  labelEn: string;
  descTh: string;
  descEn: string;
}

export const CATALOG_GROUPS: CatalogGroup[] = [
  {
    id: "notary",
    labelTh: "Notary Public / รับรองโดยทนายความ",
    labelEn: "Notary Public / Notarial Services",
    descTh:
      "งานรับรองลายมือชื่อ สำเนาถูกต้อง คำแปล หนังสือมอบอำนาจ และ Affidavit โดยทนายความผู้ทำคำรับรองลายมือชื่อและเอกสารที่ขึ้นทะเบียนกับสภาทนายความแห่งประเทศไทย",
    descEn:
      "Signature certification, true copies, certified translations, powers of attorney and affidavits executed by a Notarial Services Attorney registered with the Lawyers Council of Thailand.",
  },
  {
    id: "translation",
    labelTh: "แปลเอกสารและรับรองคำแปล",
    labelEn: "Translation & Certified Translation",
    descTh:
      "แปลเอกสารทุกภาษา พร้อมรับรองคำแปลตามที่หน่วยงานปลายทางกำหนด เช่น NAATI, นักแปลขึ้นทะเบียนกระทรวงยุติธรรม, กรมการกงสุล และสถานทูต",
    descEn:
      "Translation in every major language with the certification each receiving authority requires — NAATI, Ministry of Justice registered translators, the Department of Consular Affairs and embassies.",
  },
  {
    id: "legalization",
    labelTh: "นิติกรณ์ / รับรองกงสุลและสถานทูต",
    labelEn: "Legalization / Consular & Embassy",
    descTh:
      "รับรองนิติกรณ์เอกสารที่กรมการกงสุล กระทรวงการต่างประเทศ และรับรองต่อที่สถานเอกอัครราชทูต/สถานกงสุล รวมถึงเตรียมเอกสารสำหรับ Apostille",
    descEn:
      "Legalization at the Department of Consular Affairs (Ministry of Foreign Affairs) and onward embassy or consulate certification, including preparation for Apostille.",
  },
  {
    id: "background",
    labelTh: "ตรวจประวัติอาชญากรรมและเอกสารประกอบ",
    labelEn: "Police Clearance & Supporting Records",
    descTh:
      "ขอหนังสือรับรองความประพฤติจากกองบัญชาการตำรวจสันติบาล และประสานหนังสือตรวจประวัติของต่างประเทศ พร้อมงานพิมพ์ลายนิ้วมือและรับรองต่อเนื่อง",
    descEn:
      "Police clearance certificates from the Royal Thai Police Special Branch plus overseas criminal record checks, fingerprinting and onward legalization.",
  },
  {
    id: "visa-marriage",
    labelTh: "วีซ่า จดทะเบียนสมรส และงานทะเบียนราชการ",
    labelEn: "Visa, Marriage Registration & Civil Registry",
    descTh:
      "วีซ่าไทยและวีซ่าต่างประเทศ ใบอนุญาตทำงาน จดทะเบียนสมรสไทย–ต่างชาติ ทั้งในไทยและต่างประเทศ พร้อมงานทะเบียนราษฎรและเอกสารที่เกี่ยวข้อง",
    descEn:
      "Thai and foreign visas, work permits, Thai–foreign marriage registration in Thailand and abroad, plus civil registry documents and related filings.",
  },
];

export function getCatalogGroup(id: string): CatalogGroup | undefined {
  return CATALOG_GROUPS.find((g) => g.id === id);
}
